import { FC } from 'react';
import cx from 'classnames';
import { LightbulbIcon } from '@phosphor-icons/react';
import { IInsightItem } from '../../../models/injury';
import styles from './TeamInsightsCard.module.scss';

interface Props {
  insights: IInsightItem[];
}

const TYPE_DOT_CLASS: Record<IInsightItem['type'], string> = {
  positive: 'dotPositive',
  warning: 'dotWarning',
  negative: 'dotNegative',
  neutral: 'dotNeutral',
};

export const TeamInsightsCard: FC<Props> = ({ insights }) => {
  if (!insights.length) return null;

  return (
    <div className={styles.card}>
      <div className={styles.header}>
        <LightbulbIcon size={18} color="var(--c-warning)" weight="fill" />
        <span className={styles.title}>Insights clinici team</span>
      </div>
      <div className={styles.list}>
        {insights.map((ins, i) => (
          <div key={i} className={styles.item}>
            <div className={cx(styles.dot, styles[TYPE_DOT_CLASS[ins.type] ?? 'dotNeutral'])} />
            <span className={styles.label}>{ins.label}</span>
          </div>
        ))}
      </div>
    </div>
  );
};
